module.exports = __webpack_public_path__ + "static/img/Layer.40c6318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Layer.png
// module id = 954
// module chunks = 173